import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';

export const ChartToolTipStyled = styled.div`
  display: flex;
  justify-content: column;
  border-radius: 3px;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  z-index: 5;
  width: 240px;
  pointer-events: auto;

  ${(props) => props.theme.boxShadows.shadowMedium};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
`;
const StyledDiv = styled.div`
  display: flex;
  width: 100%;
  max-width: 240px;
`;
export const Arrow = styled.div`
  z-index: -1;
  background-color: inherit;
  width: 15px;
  height: 15px;
  visibility: hidden;

  &::before {
    visibility: visible;
    content: '';
    position: absolute;
    width: 15px;
    height: 15px;
    background-color: inherit;
    transform: rotate(45deg);
  }
  bottom: -8px;
  &::before {
    border-radius: 3px 0;
  }
`;
export const ToolTipContainer = styled(StyledDiv)`
  padding: 20px;
  flex-direction: column;
  gap: 0px;
`;
export const HeaderTextContainer = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 200px;
`;
export const ToolTipHeader = styled(StyledDiv)<{ blurScroll?: boolean }>`
  min-width: auto;
  ${(props) => (props.blurScroll ? '' : 'margin-bottom: 10px;')}
  flex-direction: row;
  overflow: hidden;
  white-space: nowrap;
  justify-content: space-between;
  z-index: 3;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;
export const ToolTipBody = styled(StyledDiv)`
  flex-direction: row;
  margin-bottom: 5px;
  justify-content: space-between;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
`;
export const ToolTipArea = styled(ToolTipBody)<{ blurScroll?: boolean }>`
  flex-direction: column;
  ${(props) =>
    props.blurScroll &&
    css`
      max-height: 120px;
      overflow-y: auto;
      padding-bottom: 10px;
      padding-top: 10px;

      // Hide the scrollbar but keep the functionality
      ::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;

      &:before {
        content: '';
        position: absolute;
        left: 0px;
        right: 0px;
        height: 20px;
        margin-top: -10px;
        background: linear-gradient(
          0deg,
          rgba(139, 167, 32, 0) 0%,
          rgba(255, 255, 255, 1) 90%
        );
        z-index: 2;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0px;
        right: 0px;
        height: 30px;
        bottom: 25px;
        background: linear-gradient(
          180deg,
          rgba(139, 167, 32, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
      }
    `}
`;
export const ToolTipDotContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const TooltipTextContainer = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 160px;
`;

export const TooltipValueContainer = styled.div`
  white-space: nowrap;
`;
